var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonuses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_730_4256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9944 79.9887C62.0826 79.9887 79.9887 62.0826 79.9887 39.9944C79.9887 17.9061 62.0826 0 39.9944 0C17.9061 0 0 17.9061 0 39.9944C0 62.0826 17.9061 79.9887 39.9944 79.9887Z",
    fill: "url(#paint0_linear_730_4256)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_730_4256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8501 30.8501V55.5401C59.8501 58.8601 57.1401 61.5701 53.8201 61.5701H26.8601C23.5401 61.5701 20.8301 58.8601 20.8301 55.5401V30.8501",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9398 22.75C51.7898 19.98 51.6498 16.64 50.5898 14.16C50.5598 14.09 50.5098 14.04 50.4398 14.02C49.7298 13.79 47.0998 15.7 44.5098 18.21C42.9098 19.77 41.5998 21.29 40.8398 22.4",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0999 22.75C29.2499 19.98 29.3899 16.64 30.4499 14.16C30.4799 14.09 30.5299 14.04 30.5999 14.02C31.3099 13.79 33.9399 15.7 36.5299 18.21C38.0899 19.73 39.3699 21.21 40.1399 22.31",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8001 35.0701C47.5401 34.6501 42.8201 38.0701 38.2001 42.5701C33.3401 47.3001 29.9801 51.8101 30.4101 52.9601C30.4301 53.0101 30.4601 53.0601 30.4901 53.1001C33.1601 55.8401 41.0301 55.6501 46.1201 50.6901C51.2101 45.7301 50.9701 39.7601 49.0701 35.3101C49.0201 35.1901 48.9201 35.1001 48.7901 35.0601L48.8001 35.0701Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4004 52.96C32.3204 51.87 34.8504 50.38 36.9204 48.75C42.6404 44.25 46.3604 39.21 48.7304 35.21",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2695 22.8899V30.0899",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7793 22.8899V30.0899",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23 22.8899H18.46C17.6537 22.8899 17 23.5436 17 24.3499V28.6199C17 29.4262 17.6537 30.0799 18.46 30.0799H62.23C63.0363 30.0799 63.69 29.4262 63.69 28.6199V24.3499C63.69 23.5436 63.0363 22.8899 62.23 22.8899Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_730_4256",
    x1: 39.9944,
    y1: 0,
    x2: 39.9944,
    y2: 79.9887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D008B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_730_4256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_730_4256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.69,
    height: 49.57,
    fill: "white",
    transform: "translate(16 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonuses);
export default __webpack_public_path__ + "static/media/bonuses.8c274b5d906483eb5ea4d5f1e48db070.svg";
export { ForwardRef as ReactComponent };